import '../../resources/css/menu.css';
import NavLink from './NavLink';
import { useGetContentQuery } from '../../store';
import useCache from '../../hooks/use-cache';
import LoginLink from './LoginLink';

export default function Navigation() {

    const { data } = useCache('menu', useGetContentQuery, 'menu');

    let renderedLinks = [];
    if (data && data.length) {
        renderedLinks = data[0].content.map((link) => {
            return <NavLink key={link.id} {...link} />
        });
    }

    return (
        <div className="menu">
            <ul>
                {renderedLinks}
            </ul>
            <LoginLink></LoginLink>
        </div >);
};